import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { KmsEnum } from '../../../serves/kms-enum';

@Component({
  selector: 'app-set-attrs',
  templateUrl: './set-attrs.component.html',
  styleUrls: ['./set-attrs.component.css']
})
export class SetAttrsComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  datas:any = [];  // 词条属性列表
  attrs:any = [];  // 模型中可选的属性
  name = '';   // 词条名称
  conceptName = '';  // 词条绑定概念id
  clickEnable = true;
  constructor(
    private jwt: SwJwtService,
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
  ) { }

  ngOnInit() {
    this.clickLoca(this.param["selectedData"]);
  }

  //知识库点击新增 或者 修改
  clickLoca(selectedData: any) {
    // 查询详情
    let params = {
      "name": selectedData.name,
      "uniqueId": selectedData.uniqueId
    }
    this.kmsService.queryRdfList(params).subscribe(
      data => {
        if (data.code == '200') {
          this.datas = data.data ? data.data : [];
        } else {
          console.log(data.msg);
        }
      }
    );
    this.name = selectedData.name;
    this.conceptName = selectedData.conceptName;
    if(!this.conceptName){
      this.box.info('当前词条尚未绑定所属概念！');
      return;
    }
    // 根据概念id查询属性字段配置
    const conceptId = selectedData.conceptId;
    this.queryAttrsByConceptId(conceptId);
  }

  // 根据概念id查询属性字段配置
  queryAttrsByConceptId(conceptId){
    this.kmsService.getAttributeForForm(conceptId).subscribe(
      res => {
        if(res.code == '200'){
          let commonAttributes = res.data.commonAttributes;
          const formTypes = KmsEnum.FORM_CONTROL_TYPES;
          const arr = [formTypes['input'],formTypes['textarea'],formTypes['richTextBox']];
          commonAttributes.forEach(el => {
            if(arr.find(el1 => el1 == el.fieldType)){
              el['id'] = el.attributeId;
              el['text'] = el.attributeName;
              this.attrs.push(el);
            }
          });
        }
      }
    );
  }

  // 属性下拉选择事件
  handleAttrChange(event,i) {
    this.datas[i].attributeName = event.text;
    console.log(this.datas[i])
  }

  // 保存词条属性映射信息
  onSubmit(){
    if(!this.conceptName){
      this.box.info('当前词条尚未绑定所属概念！');
      return;
    }
    this.clickEnable = false;
    this.kmsService.updateMaterialRdfs(this.datas).subscribe(
      res => {
        this.clickEnable = true;
        if(res.code == '200'){
          this.box.success('操作成功!');
          this.modal.toggle();
          this.callback.emit(true);
        }else{
          this.box.success('操作失败!');
        }
      }
    )
  }
}
